module.exports = __webpack_public_path__ + "bb663f3714c694d4f8d32711debbed28.png";


//////////////////
// WEBPACK FOOTER
// ./~/ushahidi-platform-pattern-library/assets/img/twitter.png
// module id = 794
// module chunks = 0